import React, { useState } from 'react';
import Layout from '../../components/Layout';
import { toast } from 'react-toastify';
import { get, post } from '../../controllers/apiController';
import { useEffect } from 'react';
import Select from 'react-select';
import { Select2 } from '../../components/Select2';
import MultiTextInput from '../../components/MultiTextInput';
import { sanitizeList } from '../../utils/list';
import { getProject, getProjectLabel, withProject } from '../../utils/project';

const AcenteEkle = () => {
    const [agencyName, setAgencyName] = useState("");
    const [representativeNames, setRepresentativeNames] = useState(['']);
    const [nationality, setNationality] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [date, setDate] = useState("");
    const [temsilciler, setTemsilciler] = useState([]);
    const [selectedTemsilci, setSelectedTemsilci] = useState(null);
    const [acenteler, setAcenteler] = useState([]);

    useEffect(() => {
        document.title = `Acente Ekle ${getProjectLabel()} | LEVELUP CRM`;

        const fetchTemsilciler = async () => {
            try {
                const res = await get("users/company-users");

                const temsilcilerMapped = res.map(temsilci => {
                    return {
                        value: temsilci.Kullanici_ID,
                        label: `${temsilci.Kullanici_Adi} ${temsilci.Kullanici_Soyadi}`
                    }
                });

                setTemsilciler(temsilcilerMapped);
            } catch (err) {
                toast.error("Temsilci verileri alınırken bir hata oluştu!");
            }
        }

        const fetchAcenteler = async () => {
            try {
                const res = await get("acenteler");

                setAcenteler(res.map(acente => ({ value: acente.Acente_Adi, label: acente.Acente_Adi })));
            } catch (err) {
                toast.error("Acente verileri alınırken bir hata oluştu!");
            }
        }

        fetchTemsilciler();
        fetchAcenteler();
    }, []);

    const createAcente = async () => {
        if (agencyName === "") {
            toast.error('Lütfen acente adını doldurunuz');
            return;
        }

        try {
            await post("acenteler", {
                project: getProject(),
                agencyName: agencyName,
                representativeNames: sanitizeList(representativeNames),
                nationality: nationality || null,
                phone: phone || null,
                email: email || null,
                date: date || null,
                representativeId: selectedTemsilci ? selectedTemsilci.value : null
            });

            setAgencyName("");
            setRepresentativeNames(['']);
            setNationality("");
            setPhone("");
            setEmail("");
            setDate("");
            setSelectedTemsilci(null);

            toast.success('Acente başarıyla oluşturuldu');
        } catch (err) {
            toast.error(err.response?.data?.message || "Acente oluşturulurken bir hata oluştu!");
        }
    }

    return (
        <Layout>
            <main className="nxl-container">
                <div className="nxl-content">
                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <div className="page-header-title">
                                <h5 className="m-b-10">LEVELUP CRM</h5>
                            </div>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><a href="./">Anasayfa</a></li>
                                <li className="breadcrumb-item"><a href={withProject("./agencies")}>Acente Yönetimi {getProjectLabel()}</a></li>
                                <li className="breadcrumb-item">Oluştur</li>
                            </ul>
                        </div>
                    </div>
                    <div className="main-content">
                        <div className="row">
                            <div className="col-xxl-12 col-md-12">
                                <div className="card stretch stretch-full">
                                    <div className="card-body">
                                        <div class="mb-5 d-flex align-items-center justify-content-between">
                                            <h5 class="fw-bold mb-0 me-4">
                                                <span class="d-block mb-2">Acente Bilgileri:</span>
                                            </h5>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label for="agencyName" className="fw-semibold">Acente Adı: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-briefcase"></i></div>
                                                    <div style={{ flex: 1 }}>
                                                        <Select
                                                            classNamePrefix="cts-select2"
                                                            placeholder="Acente adını giriniz."
                                                            options={acenteler}
                                                            inputValue={agencyName}
                                                            value={null}
                                                            controlShouldRenderValue={false}
                                                            isSearchable={true}
                                                            isClearable={false}
                                                            menuPortalTarget={document.body}
                                                            menuPosition="fixed"
                                                            noOptionsMessage={() => "Eşleşen acente bulunamadı"}
                                                            onInputChange={(newValue, actionMeta) => {
                                                                if (actionMeta.action === 'input-change') {
                                                                    setAgencyName(newValue);
                                                                }
                                                            }}
                                                            onChange={(option) => {
                                                                if (option) {
                                                                    setAgencyName(option.label);
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label for="representativeName" className="fw-semibold">Temsilci Adı: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <MultiTextInput
                                                    values={representativeNames}
                                                    onChange={setRepresentativeNames}
                                                    placeholder="Temsilci adını giriniz. (Opsiyonel)"
                                                />
                                            </div>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label for="nationality" className="fw-semibold">Uyruk: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-flag"></i></div>
                                                    <input type="text" className="form-control" id="nationality" placeholder="Uyruk giriniz. (Opsiyonel)" onChange={(e) => setNationality(e.target.value)} value={nationality} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label for="phone" className="fw-semibold">Telefon: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-phone"></i></div>
                                                    <input type="text" className="form-control" id="phone" placeholder="Telefon numarasını giriniz. (Opsiyonel)" onChange={(e) => setPhone(e.target.value)} value={phone} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label for="email" className="fw-semibold">Email: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-mail"></i></div>
                                                    <input type="text" className="form-control" id="email" placeholder="Email adresini giriniz. (Opsiyonel)" onChange={(e) => setEmail(e.target.value)} value={email} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label for="date" className="fw-semibold">Son Arama Tarihi: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-calendar"></i></div>
                                                    <input type="date" className="form-control" id="date" placeholder="Tarih seçiniz. (Opsiyonel)" onChange={(e) => setDate(e.target.value)} value={date} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-4 align-items-center">
                                            <div className="col-lg-4">
                                                <label htmlFor="temsilciSelect" className="fw-semibold">Temsilci Seç: </label>
                                            </div>
                                            <div className="col-lg-8">
                                                <div className="input-group">
                                                    <div className="input-group-text"><i className="feather-users"></i></div>
                                                    <div style={{ flex: 1 }}>
                                                        <Select2
                                                            value={selectedTemsilci}
                                                            key={"temsilciSelect"}
                                                            options={temsilciler}
                                                            isSearchable={true}
                                                            isClearable={true}
                                                            isMulti={false}
                                                            onChange={(e) => setSelectedTemsilci(e)}
                                                            style={{ width: '100%' }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-3 d-flex justify-content-start">
                                            <button onClick={createAcente} className="btn btn-primary">
                                                <i className="feather-plus me-2"></i>
                                                <span>Acente Oluştur</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </main>
        </Layout>
    );
};

export default AcenteEkle;
